// Highlight the right anchor when usser scroll to the content

let submenus = document.querySelectorAll('.desktop-nav__link-contents .desktop-nav__item');
let visibleEntry = [];
let observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      visibleEntry[entry.target.id] = entry;
    } else {
      delete visibleEntry[entry.target.id];
    }
  });

  // Sort visible entries by the top position of the boundingClientRect
  const sortedEntries = Object.values(visibleEntry).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

  // Find the corresponding title to apply the active style
  if (sortedEntries.length > 0) {
    let menuId = sortedEntries[0].target.id;
    let correspondingAnchor = sortedEntries[0].target.closest('.desktop-nav').querySelector(`.desktop-nav__anchor-links .desktop-nav__item[data-menu-id=${menuId}] .desktop-nav__link`);
    let previousActiveAnchor = document.querySelector('.desktop-nav__link.active');
    if (previousActiveAnchor) {
      previousActiveAnchor.classList.remove('active'); // Remove active class from the previous active anchor
    }
    correspondingAnchor.classList.add('active'); // Add active class to the corresponding anchor
  }
}, {
  rootMargin: '0px',
  threshold: 1.0 // 100% of the tab must be visible to trigger the observer
});
submenus.forEach(submenu => {
  observer.observe(submenu);
});